import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { OperatorProvider } from "./utils/OperatorContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <OperatorProvider>
    <App />
  </OperatorProvider>
);